const cardHeaderStyle = {
  cardHeader: {
    padding: "20px 24px 0",
    zIndex: "3 !important",
    marginBottom: "0",
    borderRadius: "8px 8px 0 0",
    border: "0",
    background: "transparent",
  },
  cardHeaderPlain: {
    marginLeft: "0px",
    marginRight: "0px",
  },
  cardHeaderProfile: {
    marginLeft: "auto",
    marginRight: "auto",
    textAlign: "center",
  },
  cardHeaderStats: {
    "& $cardHeaderIcon": {
      marginRight: "15px",
      float: "left",
    },
    "& h1,& h2,& h3,& h4,& h5,& h6": {
      margin: "0 !important",
    },
  },
  cardHeaderIcon: {
    "&$cardHeaderStats svg": {
      fontSize: "36px",
      lineHeight: "56px",
      width: "56px",
      height: "56px",
      margin: "10px 10px 4px",
    },
    "&$cardHeaderStats i,&$cardHeaderStats .material-icons": {
      fontSize: "36px",
      lineHeight: "56px",
      width: "56px",
      height: "56px",
      margin: "10px 10px 4px",
    },
  },
  warningCardHeader: {
    color: "#fff",
    background: "linear-gradient(135deg, #f59e0b, #fbbf24)",
    boxShadow: "0 4px 15px rgba(245,158,11,0.3)",
    borderRadius: "8px",
    padding: "16px",
    margin: "-20px 16px 0",
  },
  successCardHeader: {
    color: "#fff",
    background: "linear-gradient(135deg, #22c55e, #4ade80)",
    boxShadow: "0 4px 15px rgba(34,197,94,0.3)",
    borderRadius: "8px",
    padding: "16px",
    margin: "-20px 16px 0",
  },
  dangerCardHeader: {
    color: "#fff",
    background: "linear-gradient(135deg, #ef4444, #f87171)",
    boxShadow: "0 4px 15px rgba(239,68,68,0.3)",
    borderRadius: "8px",
    padding: "16px",
    margin: "-20px 16px 0",
  },
  infoCardHeader: {
    color: "#fff",
    background: "#2f72f2",
    boxShadow: "0 8px 18px rgba(47,114,242,0.22)",
    borderRadius: "8px",
    padding: "16px",
    margin: "-20px 16px 0",
  },
  primaryCardHeader: {
    color: "#fff",
    background: "#2f72f2",
    boxShadow: "0 8px 18px rgba(47,114,242,0.22)",
    borderRadius: "8px",
    padding: "16px",
    margin: "-20px 16px 0",
  },
  roseCardHeader: {
    color: "#fff",
    background: "linear-gradient(135deg, #ec4899, #f472b6)",
    boxShadow: "0 4px 15px rgba(236,72,153,0.3)",
    borderRadius: "8px",
    padding: "16px",
    margin: "-20px 16px 0",
  },
};

export default cardHeaderStyle;
